import React from 'react'

import { Form, Table } from '_zari/core'

const FilaDetalleTemplate = ({ index, row, actualizarFilaHandler, eliminarFilaHandler }) => {
  const [cantidad, setCantidad] = React.useState(row.cantidad)
  const [precio, setPrecio] = React.useState(row.precio)

  const keyUpCantidadHandler = e => {
    const keyCode = e.keyCode

    let __focusCantidad = true
    let __focusPrecio = false
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      __focusCantidad = false
      __focusPrecio = true
      saltarFila = false
      saltarCampo = true
    }

    actualizarFilaHandler({
      ...row,
      cantidad,
      precio,
      __focusCantidad,
      __focusPrecio,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownCantidadHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const keyUpPrecioHandler = e => {
    const keyCode = e.keyCode

    let __focusPrecio = true
    let saltarFila = false
    let saltarCampo = false

    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()

      __focusPrecio = false
      saltarFila = true
      saltarCampo = true
    }

    actualizarFilaHandler({
      ...row,
      cantidad,
      precio,
      __focusPrecio,
      saltarFila,
      saltarCampo
    })
  }

  const keyDownPrecioHandler = e => {
    const keyCode = e.keyCode
    if (keyCode === 13 || keyCode === 9) {
      e.preventDefault()
    }
  }

  const clickEliminarFilaHandler = () => {
    window.setTimeout(() => {
      eliminarFilaHandler(row._idFila)
    }, 150)
  }

  const inputCantidadRef = React.useRef()
  React.useEffect(() => {
    if (row.__filaActiva && row.__focusCantidad) {
      window.setTimeout(() => {
        inputCantidadRef.current.select()
      }, 250)
    }
  }, [row.__filaActiva, row.__focusCantidad])

  return (
    <>
      <tr>
        <td>{parseFloat(index) + 1}</td>
        <td>{row.codigoProducto || '--'}</td>
        <td>{row.nombreProducto || '--'}</td>
        <td>{row.nombreUnidadDeMedida || row.unidadMedida || '--'}</td>
        <td>
          <Form.InputNumber
            ref={inputCantidadRef}
            value={cantidad}
            onChange={e => setCantidad(e.target.value)}
            onKeyUp={keyUpCantidadHandler}
            onKeyDown={keyDownCantidadHandler}
          />
        </td>
        <td>
          <Form.InputNumber
            value={precio}
            onChange={e => setPrecio(e.target.value)}
            onKeyUp={keyUpPrecioHandler}
            onKeyDown={keyDownPrecioHandler}
            autoFocus={row.__filaActiva && row.__focusPrecio}
          />
        </td>
        <td>{row.subTotal || '--'}</td>
        <td>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={clickEliminarFilaHandler}>
                Eliminar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </td>
      </tr>
    </>
  )
}

export default React.memo(FilaDetalleTemplate)
